import { useEffect, useMemo, useState } from 'react'
import {
  addCustomEcommerceSegment,
  getEcommerceSegmentOptions,
  loadCustomEcommerceSegments,
} from '@/constants/ecommerceSegments'
import { SearchableCreatableField } from '@/components/shared/SearchableCreatableField'

type Props = {
  value: string
  onChange: (value: string) => void
  error?: string
}

export function EcommerceSegmentField({ value, onChange, error }: Props) {
  const [customSegments, setCustomSegments] = useState<string[]>(() => loadCustomEcommerceSegments())

  useEffect(() => {
    setCustomSegments(loadCustomEcommerceSegments())
  }, [])

  const options = useMemo(() => getEcommerceSegmentOptions(customSegments), [customSegments])

  return (
    <SearchableCreatableField
      value={value}
      onChange={onChange}
      options={options}
      label='Nicho do E-commerce'
      placeholder='Ex: Cosméticos, Moda, Calçados…'
      hint='Tipo de loja (vertical), não a plataforma tecnológica.'
      error={error}
      findDuplicate={(name, list) =>
        list.find((item) => item.toLowerCase() === name.trim().toLowerCase()) ?? null
      }
      onPersistOption={(name) => {
        const result = addCustomEcommerceSegment(name)
        if (!result.ok) return result
        setCustomSegments(loadCustomEcommerceSegments())
        return { ok: true as const }
      }}
    />
  )
}
